import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const PrivacyPolicyPage = () => {
  return (
    <div data-testid="privacy-policy-page" className="min-h-screen bg-[#FAFAF8]">
      <Header />
      <main>
        {/* Hero */}
        <section className="bg-[#2D5A27] py-16 md:py-20">
          <div className="container mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
            <h1
              data-testid="privacy-policy-headline"
              className="font-heading text-3xl md:text-4xl lg:text-5xl text-white font-bold"
            >
              Privacy Policy
            </h1>
            <p className="text-white/80 mt-4">Last updated: December 2025</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-12 md:py-16">
          <div className="container mx-auto max-w-4xl px-4 md:px-6 lg:px-8">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
              <div className="prose prose-lg max-w-none text-[#4B5563]">
                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  1. Introduction
                </h2>
                <p className="mb-6">
                  CasaCurate Store ("we," "our," or "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our landscaping services.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  2. Information We Collect
                </h2>
                <p className="mb-4">We may collect information about you in various ways:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li><strong>Personal Data:</strong> Name, email address, phone number, mailing address, and other similar contact data you provide when requesting an estimate or contacting us.</li>
                  <li><strong>Property Information:</strong> Details about your property, landscaping needs, and project preferences.</li>
                  <li><strong>Usage Data:</strong> Information about how you interact with our website, including IP address, browser type, pages visited, and time spent on pages.</li>
                </ul>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  3. How We Use Your Information
                </h2>
                <p className="mb-4">We use the information we collect to:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li>Respond to your inquiries and provide estimates</li>
                  <li>Schedule and deliver landscaping services</li>
                  <li>Communicate with you about your projects</li>
                  <li>Improve our website and services</li>
                  <li>Send you marketing communications (with your consent)</li>
                  <li>Comply with legal obligations</li>
                </ul>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  4. Information Sharing
                </h2>
                <p className="mb-6">
                  We do not sell, trade, or otherwise transfer your personal information to outside parties except as described in this policy. We may share information with trusted service providers who assist us in operating our business, provided they agree to keep this information confidential.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  5. Data Security
                </h2>
                <p className="mb-6">
                  We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  6. Cookies
                </h2>
                <p className="mb-6">
                  Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings, but this may affect certain features of our website.
                </p>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  7. Your Rights
                </h2>
                <p className="mb-4">You have the right to:</p>
                <ul className="list-disc pl-6 mb-6 space-y-2">
                  <li>Access and receive a copy of your personal data</li>
                  <li>Request correction of inaccurate data</li>
                  <li>Request deletion of your personal data</li>
                  <li>Opt-out of marketing communications</li>
                </ul>

                <h2 className="font-heading text-2xl text-[#1A2C22] font-semibold mb-4">
                  8. Contact Us
                </h2>
                <p className="mb-4">
                  If you have questions about this Privacy Policy, please contact us:
                </p>
                <p className="mb-2"><strong>CasaCurate Store</strong></p>
                <p className="mb-2">1513 Sunset Boulevard, Los Angeles, CA 90027</p>
                <p className="mb-2">Phone: +1-771-1871-113</p>
                <p>Email: info@casacurate.store</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
